import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataServiceConfig,
    EntityCollectionServiceBase,
    EntityCollectionServiceElementsFactory,
    HttpUrlGenerator
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../../shared/services/logging';
import { EfaactDataService } from '../../../efaact.data-service';
import { InvoiceSelections } from './invoice-selections.model';
export const entityName = 'InvoicePropertyShared';
@Injectable({ providedIn: 'root' })
export class InvoiceSelectionsDataService extends EfaactDataService<InvoiceSelections> {
    mapItems(item: InvoiceSelections): InvoiceSelections {
        return {
            id: item.Invoicepropertysharedid,
            ...item,
            Status: item.Status || { StatusCode: 0, Message: '' }
        };
    }
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
    // getAll() {
    //     return of((data as any).default).pipe(
    //         map(items => items.map(p => this.mapItems(p)))
    //     );
    // }
}
